import { render, staticRenderFns } from "./SettingsFences.vue?vue&type=template&id=2c9ddbbc&scoped=true"
import script from "./SettingsFences.vue?vue&type=script&lang=js"
export * from "./SettingsFences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9ddbbc",
  null
  
)

export default component.exports